export default __webpack_public_path__ + "static/media/login-background.25493a06.webp";